import { render, staticRenderFns } from "./waters.vue?vue&type=template&id=118fc796&"
import script from "./waters.vue?vue&type=script&lang=js&"
export * from "./waters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports